angular.module('NaviaqWebApp').directive('activitiesOperationLogs', [function () {
    'use strict';

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/report/directives/activities-operation-logs.html',
        link: function (scope, element, attrs) {
        }
    };
}]);
